<template>
  <div class="tools collapse header" @click="change" :data-collapsed="collapsed">
    <button title="Ouvrir / Fermer"><svgicon name="sport/games/collapse" /></button>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'ToolsCollapseHeader',
  props: {
    title: String,
    defaultCollapse: Boolean
  },
  data () {
    return {
      collapsed: this.defaultCollapse
    }
  },
  methods: {
    change () {
      this.collapsed = !this.collapsed
      this.$emit('collapse', this.collapsed)
    }
  }
}
</script>

<style>
  .tools.collapse.header{
    display:flex;
    flex-direction:row;
    min-height:20px;
    height:fit-content;
    margin:5px;
    cursor:pointer
  }
  .tools.collapse.header > button{
    background-color:transparent;
    border:none
  }
  .tools.collapse.header > button > svg{
    fill:transparent;
    stroke:var(--color-primary);
    stroke-width:20px;
    stroke-linecap:round;
    stroke-linejoin:round;
    transition:all .5s ease-in-out;
    transform:rotate(0deg)
  }
  .tools.collapse.header:hover > button > svg,
  .tools.collapse.header[data-collapsed="true"] > button > svg {
    transform:rotate(180deg)
  }
  .tools.collapse.header[data-collapsed="true"]:hover > button > svg{
    transform:rotate(0deg)
  }
  .tools.collapse.header > h3{
    margin:0;
    padding:0;
    line-height:20px;
    font-size:14px;
    font-weight:400;
    color:var(--color-primary);
    margin-left:10px
  }
</style>
